import { lazy } from 'react';

export default [
    {
        path: '/acme-preorder',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'AcmePreorderLayout' */ './layout')),
    },
];
